export const UserOnCompanyFragment = gql`
  fragment UserOnCompanyFragment on UserOnCompany {
    company {
      id
    }
    isOnlyAdminOnCompany
    role
    title
    user {
      ...UserDataFragment
    }
  }
`
